import { withFormik } from "formik";
import * as Yup from "yup";
const SUPPORTED_FORMATS = [
  "image/jpg",
  "image/jpeg",
  "image/png",
  "image/svg+xml",
  "image/svg",
  "image/gif"
];
const formikEnhancer = withFormik({
  validationSchema: Yup.object().shape({
    name: Yup.string()
      .matches(/^[a-zA-Z /.]+$/, "Please enter valid name")
      .required("Please Enter Name"),
    email: Yup.string()
      .email("Please enter valid email")
      .required("Please Enter Email"),
    phone: Yup.string()
      .matches(/^\d+$/, "Please Enter valid Phone Number")
      .length(10, "Please Enter valid phone number")
      .required("Please Enter Phone Number"),
    // Make file_image optional. It can be a string (existing file path) or a File/Blob when uploading.
    file_image: Yup.mixed()
      .nullable()
      .test(
        "fileFormat",
        "Only .jpg, .jpeg, .png, .svg, .gif files are allowed.",
        value => {
          if (!value) return true; // optional
          // If it's a string (existing filename/path), skip format check
          if (typeof value === "string") return true;
          // Otherwise assume it's a File/Blob and check the type
          return (
            value &&
            value.type &&
            SUPPORTED_FORMATS.includes(value.type.toLowerCase())
          );
        }
      ),
    status: Yup.string().required("Please select status"),
    venue_data: Yup.array()
      .min(1, "Please select at least one venue")
      .required("Please select venue data")
  }),
  validateOnMount: true,
  mapPropsToValues: props => ({
    name: "",
    email: "",
    phone: "",
    file_image: "",
    status: true,
    venue_data: [],
    service_data: [],
    is_manager: true
  }),
  handleSubmit: values => {},
  displayName: "CustomValidationForm",
  enableReinitialize: true
});

export default formikEnhancer;
